import { useEffect, useRef } from 'react';

const HOVER_TARGET_SELECTOR = 'a, button, [role="button"], input, textarea, select, .cursor-hover';

const CustomCursor = () => {
  const dotRef = useRef<HTMLDivElement>(null);
  const ringRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches) return;

    document.body.classList.add('custom-cursor-active');

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let ringX = mouseX;
    let ringY = mouseY;
    let rafId: number;

    const handleMouseMove = (e: MouseEvent) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dotRef.current?.style.setProperty('transform', `translate3d(${mouseX}px, ${mouseY}px, 0)`);
    };

    const animateRing = () => {
      ringX += (mouseX - ringX) * 0.16;
      ringY += (mouseY - ringY) * 0.16;
      ringRef.current?.style.setProperty('transform', `translate3d(${ringX}px, ${ringY}px, 0)`);
      rafId = requestAnimationFrame(animateRing);
    };

    const handleMouseOver = (e: MouseEvent) => {
      if ((e.target as HTMLElement)?.closest?.(HOVER_TARGET_SELECTOR)) {
        ringRef.current?.classList.add('cursor-ring--hover');
      }
    };

    const handleMouseOut = (e: MouseEvent) => {
      if ((e.target as HTMLElement)?.closest?.(HOVER_TARGET_SELECTOR)) {
        ringRef.current?.classList.remove('cursor-ring--hover');
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleMouseOver);
    window.addEventListener('mouseout', handleMouseOut);
    rafId = requestAnimationFrame(animateRing);

    return () => {
      document.body.classList.remove('custom-cursor-active');
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleMouseOver);
      window.removeEventListener('mouseout', handleMouseOut);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
      <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
    </>
  );
};

export default CustomCursor;
